import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import auth from './auth';
import { hasPermission, hasRole } from '../../security/session';

export const Protegerotas=({component:Component, roles = [], permissions = [], ...rest})=>{
    return(
        <Route {...rest} 
        render={props=>{
                if(auth.isAuthenticated() && hasRole(roles) && hasPermission(permissions)){
                    return <Component {...props}/>;
         

                }else{
                    return <Redirect
                    to={"/"}
                    />;
                }
                    }
        } />
    )
}
